import { render, staticRenderFns } from "./SKR.vue?vue&type=template&id=3d2de36e&scoped=true&"
import script from "./SKR.vue?vue&type=script&lang=ts&"
export * from "./SKR.vue?vue&type=script&lang=ts&"
import style0 from "./SKR.vue?vue&type=style&index=0&id=3d2de36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2de36e",
  null
  
)

export default component.exports